import { createContext, useContext } from 'react';

export const ModalContext = createContext({
  type: 'dialog' as 'dialog' | 'drawer',
  isDrawer: false,
});

export const useModalContext = () => useContext(ModalContext);
